import Cookies from "js-cookie";

const TemplateProducts = {
  init: function () {
    this.events();
  },

  events: function () {
    $(".prod-child-term__button").on("click", function (e) {
      e.preventDefault();
      let btn = $(this);
      let content = btn.next();
      if (!btn.hasClass("prod-child-term__button--open")) {
        $(".prod-child-term__content").slideUp();
        $(".prod-child-term__button").removeClass(
          "prod-child-term__button--open"
        );
      }
      // Check if has content
      if (!btn.attr("loaded")) {
        TemplateProducts.loadCategoryPosts(btn);
      } else {
        content.slideToggle();
        if (btn.hasClass("prod-child-term__button--open")) {
          btn.removeClass("prod-child-term__button--open");
        } else {
          btn.addClass("prod-child-term__button--open");
        }
      }
    });

    $("body").on("click", ".spec-yes", function (e) {
      e.preventDefault();

      Cookies.set("i_am_specialist", true, {
        expires: 7,
      });

      $(this).closest(".prod-child-term__only-spec").fadeOut(250);
    });

    $(".popup").on("click", ".children_infants-yes", function () {
      Cookies.set("children_infants_disclaimer", true, {
        expires: 365,
      });
    });

    $(".popup").on("click", ".grownups-yes", function () {
      Cookies.set("grownups_disclaimer", true, {
        expires: 365,
      });
    });

    if (location.hash) {
      setTimeout(function () {
        window.scrollTo(0, 0);
      }, 1);
    }

    $(window).on("load", function () {
      if (location.hash) {
        let $o = $(location.hash);
        $o.find("button").trigger("click");
        if ($o.length) {
          $("html, body").animate(
            {
              scrollTop: $o.offset().top - 120,
            },
            1500
          );
        }
      }
    });
  },

  loadCategoryPosts: function (btn) {
    let content = btn.next();

    $.ajax({
      url: ajaxurl,
      type: "POST",
      data: {
        action: "get_cat_products",
        prod_cat: $(btn).data("id"),
      },
      beforeSend: function () {
        btn.addClass("prod-child-term__button--loading");
      },
      success: function (response) {
        btn.attr("loaded", true);
        btn.addClass("prod-child-term__button--open");
        btn.removeClass("prod-child-term__button--loading");
        content.html(response);
        content.slideDown();
      },
    });
  },
};

export default TemplateProducts;
